import queryString from 'querystring';
import get from 'lodash/get';

export default eismoUrl => {
  const [, queryParams] = eismoUrl.split('?');
  const params = queryString.parse(queryParams);
  return get(params, 'category', null);
};
